import TitleContentBlock from './TitleContentBlock'
import ImageContentBlock from './ImageContentBlock'
import ProgressContentBlock from './ProgressContentBlock'
import BlogItem from './BlogItem'

export const contentBlockMaps = {
    TitleContentBlock: TitleContentBlock,
    ImageContentBlock: ImageContentBlock,
    ProgressContentBlock: ProgressContentBlock,
    BlogItem: BlogItem
}

export default contentBlockMaps